module.exports = __webpack_public_path__ + "img/sidebar_el_202627.1769c5b2.png";